import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface SupplierTypeBadgeProps {
  isInternal: boolean;
}

export function SupplierTypeBadge({ isInternal }: SupplierTypeBadgeProps) {
  const { t } = useTranslation();

  return (
    <Box
      bg="entityDirectory.badgeBackground"
      color="entityDirectory.mutedText"
      display="inline-flex"
      fontSize="10px"
      fontWeight="semibold"
      lineHeight="12px"
      alignSelf="flex-start"
      px={2}
      py={1}
    >
      {isInternal ? t('suppliers.internal') : t('suppliers.external')}
    </Box>
  );
}
